export default __webpack_public_path__ + "public/images/services/IntroServicesImg.png?5a186594";